







import { Storage, Constants } from '@/services'
import SignupForm from '@/components/login/SignupForm.vue'

export default {
  name: 'VerifyEmail',
  components: {
    SignupForm,
  },
  computed: {
    showLogin: () => {
      return true
    },
    sourcePretty: function () {
      if (this.source === 'Pinners2020') return 'Pinners'
      return 'Pinners'
    },
    source: function () {
      const { source } = this.$router.currentRoute.query
      return source
    },
  },
}
